<div class="flex-column gap">
    <div class="flex justify-content-between align-items-center gap">
        <app-select-button-input
            id="type"
            [form]="form"
            [options]="types"
            [clear]="false"
            prefix="ePrescriptions.search.filter.types.">
        </app-select-button-input>

        <app-multi-select-input label="ePrescriptions.search.filter.atcGroup" [staticOptions]="[]"
            [form]="form" id="atcGroup"></app-multi-select-input>
    </div>

    <!--    seznam leku-->
    <app-table
        translatePrefix="ePrescriptions.search."
        [columns]="columns"
        dataKey="code"
        [gridData]="store.data.getMedications()"
        [refreshCallback]="store.api.getMedications"
        selectionMode="single"
        (selectionChanged)="selection($event)"
        [showSearchBar]="false"
    >
    </app-table>

    @if (selectedMedication()) {
        <div class="flex justify-content-between align-items-center gap">
            <div class="flex gap-small">
                <app-radio-input [form]="form" id="sort" [staticOptions]="sortTypes"
                    prefix="ePrescriptions.search.filter.sortTypes." [autoSelectFirst]="true"></app-radio-input>
                <app-button label="ePrescriptions.buttons.save"></app-button>
            </div>

            <app-insurance-company-select-input id="insuranceAbbr"
                prefix="ePrescriptions.form." [form]="form"></app-insurance-company-select-input>
        </div>

        <!--    seznam nahrad-->
        <div style="height: 35vh;"></div>
    }
</div>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons primaryButtonLabel="ePrescriptions.buttons.select"
        [primaryButtonDisability]="!selectedMedication()" (primaryClickEvent)="select($event)"
        (secondaryClickEvent)="dialogRef.close()">
        <app-button icon="pi-arrow-right-arrow-left" label="ePrescriptions.buttons.interaction" severity="secondary"
            (clickEvent)="interaction()"></app-button>
    </app-action-buttons>
</div>
